<template>
  <div ref="mapContainer" class="bmap-container"></div>
</template>

<script setup>
import { ref, onMounted } from 'vue'

const mapContainer = ref(null)

const initMap = () => {
  if (mapContainer.value) {
    const map = new BMapGL.Map(mapContainer.value) // 使用 BMapGL
    const point = new BMapGL.Point(113.024551, 28.196726) // 新湖南大厦产业楼坐标
    map.centerAndZoom(point, 17)
    map.enableScrollWheelZoom(true)
    
    // 添加控件
    map.addControl(new BMapGL.NavigationControl())
    map.addControl(new BMapGL.ScaleControl())
    
    // 添加标记点
    const marker = new BMapGL.Marker(point)
    map.addOverlay(marker)
    
    // 添加信息窗口
    const infoWindow = new BMapGL.InfoWindow("长沙市开福区芙蓉中路一段442号新湖南大厦产业楼", {
      width: 300,
      height: 80,
      title: "湖南美音网络技术有限公司"
    })
    
    // 点击标记时打开信息窗口
    marker.addEventListener('click', () => {
      map.openInfoWindow(infoWindow, point)
    })
    
    // 默认打开信息窗口
    map.openInfoWindow(infoWindow, point)
  }
}

onMounted(() => {
  // 确保百度地图脚本已加载
  if (typeof BMapGL === 'undefined') {
    const script = document.createElement('script')
    script.src = `https://api.map.baidu.com/api?v=1.0&type=webgl&ak=xyEsbjVnohQRPtGDZ4ihikhOt2rPIxMU&callback=initMap`
    document.head.appendChild(script)
    window.initMap = initMap
  } else {
    initMap()
  }
})
</script>

<style scoped>
.bmap-container {
  width: 100%;
  height: 400px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}
</style> 